/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.profiles.rpc.ProfilesPublicRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getProfileRpc = {
  serviceName: 'com.hubspot.marketplace.profiles.rpc.ProfilesPublicRpc',
  rpcName: 'getProfile',
  auth: 'external',
  fingerprint: 'vNGHFvrLWrXNzvaEBVjm6JwP6LXzGzX8',
  na1Only: true,
  isStreaming: false,
  isHublessAppAuth: false
};